{
  "el": {
    "navbar": {
      "customer": {
        "after_care": "Παρατηρήσεις",
        "announcements": "Ενημερώσεις έργου",
        "dashboard": "Αρχική",
        "decisions": "Αποφάσεις",
        "documents": "Έγγραφα",
        "inspirations": "Εμπνεύσεις",
        "installments": "Οικονομικά",
        "profile": "Το προφίλ σου",
        "projectinfo": "Πληροφορίες",
        "question_lists": "FAQ",
        "surveys": "Ερωτηματολόγια",
        "ticket": {
          "new": "Νέα συνομιλία"
        },
        "tickets": "Συνομιλίες",
        "units": "Ταυτότητα κτιρίου"
      },
      "employee": {
        "all_projects": "Έργα",
        "client": "Προφίλ {client}",
        "contacts": "Επαφές",
        "customer": "Πελάτης",
        "dashboard": "Αρχική",
        "employee": "Μέλος ομάδας",
        "overview": "Επισκόπηση",
        "partner": "Συνεργάτης",
        "profile": "Το προφίλ σου",
        "project": {
          "after_care": "Παρατηρήσεις",
          "decisions": "Αποφάσεις",
          "documents": "Έγγραφα",
          "email_conversations": "Εισερχόμενα email",
          "info": "Πληροφορίες",
          "installments": "Οικονομικά",
          "milestones": "Ορόσημα",
          "news": "Ανακοινώσεις",
          "question_lists": "FAQ",
          "sales": "Πωλήσεις",
          "surveys": "Ερωτηματολόγια",
          "tasks": "Εργασίες",
          "todos": "Εργασίες"
        },
        "projects": "Έργα",
        "ticket": {
          "new": "Νέα συνομιλία"
        },
        "tickets": "Συνομιλίες"
      },
      "landmarks": {
        "employee": {
          "client": {
            "primary": "Κύρια πλοήγηση",
            "secondary": "Δευτερεύουσα πλοήγηση"
          }
        }
      },
      "partner": {
        "contacts": "Επαφές",
        "dashboard": "Αρχική",
        "profile": "Το προφίλ σου",
        "project": {
          "after_care": "Παρατηρήσεις",
          "decisions": "Αποφάσεις",
          "documents": "Έγγραφα",
          "tickets": "Συνομιλίες"
        },
        "projects": "Έργα"
      },
      "topnavbar": {
        "company": "Οργανισμός",
        "helpcenter": "Κέντρο βοήθειας",
        "inviteManageMembers": "Πρόσκληση και διαχείριση μελών",
        "logout": "Αποσύνδεση",
        "profile": "Προφίλ",
        "searchTeam": "Αναζήτηση οργανισμού",
        "selectTeam": "Επιλογή οργανισμού",
        "settings": "Ρυθμίσεις",
        "team": "Ομάδα"
      }
    }
  }
}
